import { FC } from 'react';
import { LoaderCircle } from '@edikk-edikk/shared';
import { useAdvertCardContext } from '#advert/components/card';
import { AppSvgSpriteMonoIcon } from '#src/svg';

type PropsType = {
  isProcess: boolean;
};

const FavoriteToggleIcon: FC<PropsType> = ({
  isProcess,
}) => {
  const {
    advert: {
      isFavorite,
    },
  } = useAdvertCardContext();

  if (isProcess) {
    return <LoaderCircle sizeXs borderColor="#fff" />;
  }

  return <AppSvgSpriteMonoIcon name={isFavorite ? 'heart-fill' : 'heart-stroke'} size={18} />;
};

export { FavoriteToggleIcon };
